<template>
  <div class="d-flex flex-wrap w-100 menu align-items-center px-3 px-lg-4 py-2 py-lg-0 mobile-header-adjustment">
    <!-- Hamburger for mobile -->
    <div class="d-block d-lg-none order-1">
      <b-navbar-toggle target="nav-collapse" class="custom-toggler border-0">
        <template #default="{ expanded }">
          <i class="fas fa-bars toggle-icon" v-if="!expanded"></i>
          <svg v-else class="toggle-icon" style="height: calc(1em + 2px); width: calc(1em + 2px);" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <line x1="2" y1="5" x2="18" y2="5"></line>
            <line x1="2" y1="12" x2="9" y2="12"></line>
            <line x1="2" y1="19" x2="18" y2="19"></line>
            <polyline points="20 8 13 12 20 16"></polyline>
          </svg>
        </template>
      </b-navbar-toggle>
    </div>

    <!-- Logo -->
    <div class="mr-lg-auto order-2 flex-grow-1 flex-lg-grow-0 text-center text-lg-left logo-container-mobile">
      <b-navbar variant="faded" type="light" class="p-0 d-inline-block">
        <b-navbar-brand class="clickable m-0" @click="getHome">
          <img src="@/assets/images/logo_verde.svg" class="d-inline-block align-top logo" alt="Logo" />
        </b-navbar-brand>
      </b-navbar>
    </div>

    <!-- Profile Dropdown moved outside collapse to be always visible on top right -->
    <div class="order-3 order-lg-4 ml-auto ml-lg-3 profile-container">
      <Dropdown :text="userName" :userImage="$props.userImage" class="custom-profile-dropdown">
        <div class="d-flex flex-column">
          <DropdownItem class="dropdown-item-center pt-4" @click="openImageProfileModal">
            <div class="user-img-gr">
              <img :src="$props.userImage" v-if="$props.userImage" />
              <img src="@/assets/icons/user.svg" v-else />
              <div class="icon-photos">
                <img src="@/assets/icons/add-a-photo.svg" />
              </div>
            </div>
            <p class="pt-4">Adicione ou altere sua foto de perfil</p>
          </DropdownItem>
          <DropdownDivider />
          <DropdownItem @click="changePassword">
            <h4>Alterar Senha</h4>
          </DropdownItem>
          <DropdownItem @click="navigateRequestHistory" v-if="validateRole(PermissionList.REQUEST_HISTORY_MENU)">
            <h4>Histórico de Solicitações</h4>
          </DropdownItem>
          <DropdownItem @click="onClickUseTerm" v-if="validateRole(PermissionList.USE_TERM_MENU)">
            <h4>Termos de Uso</h4>
          </DropdownItem>
          <DropdownItem @click="startTourManually" v-if="validateRole(PermissionList.GUIDED_TOUR_MENU)">
            <h4>Reiniciar Tour Guiado</h4>
          </DropdownItem>
          <DropdownItem @click="logout">
            <div class="d-flex align-items-center logout-item">

              <i class="fas fa-sign-out-alt logout-item__icon"></i>
              <h4 class="logout-item__text">Sair</h4>
            </div>
          </DropdownItem>
        </div>
      </Dropdown>
    </div>

    <!-- Collapsed Menu Items -->
    <b-collapse id="nav-collapse" ref="navbarCollapse" is-nav
      class="order-4 order-lg-3 flex-grow-1 header-menu-collapse">
      <b-navbar-nav class="ml-auto mr-lg-5 menu tour-step-1">
        <b-nav-item v-if="validateRole(PermissionList.HOME_MENU)" @click="getHome" class="home-nav-item">
          <span class="nav-link" :class="{ 'active': selectRoute(this.linkHome) }">Início</span>
        </b-nav-item>
        <b-nav-item @click.stop.prevent v-if="validateRole(PermissionList.INSTITUTIONAL_PAGE_MENU)">
          <CustomDropdown title="Institucional" :items="this.dropdownInstitucional()" :route="this.linkInstitucional"
            @item-clicked="closeAllDropdowns" :active="selectRoute(this.linkInstitucional)" />
        </b-nav-item>
        <b-nav-item @click.stop.prevent v-if="validateRole(PermissionList.REGISTER_MENU)">
          <CustomDropdown title="Cadastro" :items="this.dropdownCadastro()" :route="this.linkCadastro"
            @item-clicked="closeAllDropdowns" :active="selectRoute(this.linkCadastro)" />
        </b-nav-item>
        <b-nav-item @click.stop.prevent v-if="validateRole(PermissionList.DECLARATIONS_MENU)">
          <CustomDropdown title="Declarações" :items="this.dropdownDeclaracoes()" :route="this.linkDeclaracoes"
            @item-clicked="closeAllDropdowns" :active="selectRoute(this.linkDeclaracoes)" />
        </b-nav-item>
        <b-nav-item id="tour-step-3" @click.stop.prevent v-if="validateRole(PermissionList.VIRTUAL_OFFICE_MENU)">
          <CustomDropdown title="Consultório Virtual" :items="this.dropdownConsultorioVirtual()"
            :route="this.linkConsultorioVirtual" @item-clicked="closeAllDropdowns"
            :active="selectRoute(this.linkConsultorioVirtual)" />
        </b-nav-item>
        <b-nav-item @click.stop.prevent v-if="validateRole(PermissionList.BENEFIT_MENU)">
          <CustomDropdown title="Benefícios" :items="this.dropdownBeneficios()" :route="this.linkBeneficios"
            @item-clicked="closeAllDropdowns" :active="selectRoute(this.linkBeneficios)" />
        </b-nav-item>
        <b-nav-item id="tour-step-2" @click.stop.prevent v-if="validateRole(PermissionList.FINANCIAL_MENU)">
          <CustomDropdown title="Financeiro" :items="this.dropdownFinanceiro()" :route="this.linkFinanceiro"
            @item-clicked="closeAllDropdowns" :active="selectRoute(this.linkFinanceiro)" />
        </b-nav-item>

        <b-nav-item @click.stop.prevent v-if="
          validateRole(PermissionList.CONTENT_TRAINING_MANAGEMENT_MENU) &&
          !validateRole(PermissionList.HOME_MENU)
        ">
          <CustomDropdown title="Treinamentos" :items="this.dropContentTraining()"
            :route="this.linkContentTrainingManagement" @item-clicked="closeAllDropdowns"
            :active="selectRoute(this.linkContentTrainingManagement)" />
        </b-nav-item>

        <b-nav-item @click.stop.prevent v-if="
          validateRole(PermissionList.CONTENT_MANAGEMENT_MENU) &&
          !validateRole(PermissionList.HOME_MENU)
        ">
          <CustomDropdown title="Relatórios" :items="this.dropdownContentReportManagement()"
            :route="this.linkContentReportManagement" @item-clicked="closeAllDropdowns"
            :active="selectRoute(this.linkContentReportManagement)" />
        </b-nav-item>

        <b-nav-item @click.stop.prevent v-if="
          validateRole(PermissionList.CONTENT_MANAGEMENT_MENU) &&
          !validateRole(PermissionList.HOME_MENU)
        ">
          <CustomDropdown title="Gestão de conteúdos" :items="this.dropContentManagement()"
            :route="this.linkContentManagement" @item-clicked="closeAllDropdowns"
            :active="selectRoute(this.linkContentManagement)" />
        </b-nav-item>
        <b-nav-item id="tour-step-5" @click.stop.prevent :active="selectRoute('/perguntas-frequentes')"
          @click="selectNavItemClick('perguntas-frequentes')" @item-clicked="closeAllDropdowns"
          v-if="validateRole(PermissionList.FAQ_MENU)">
          <img class="icon-faq" src="@/assets/icons/help-circle-outline.svg" />
        </b-nav-item>
        <b-nav-item @click.stop.prevent v-show="false" v-if="validateRole(PermissionList.FAQ_MENU)">
          <DigitalCheckin />
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </div>
</template>

<script>
import RoutesPaths from "../router/router-structure/routes-paths";
import CustomDropdown from "../components/custom-dropdown/CustomDropdown.vue";
import Dropdown from "../components/dropdown/Dropdown.vue";
import DropdownItem from "../components/dropdown/DropdownItem.vue";
import DropdownDivider from "../components/dropdown/DropdownDivider.vue";
import isAble from "../utils/permissions/is-able";
import { PermissionList } from "../static-data/PermissionList";
import DigitalCheckin from "../modules/digital-checkin/DigitalCheckin.vue";

import {
  dropdownInstitucional,
  dropdownCadastro,
  dropdownDeclaracoes,
  dropdownConsultorioVirtual,
  dropdownBeneficios,
  dropdownFinanceiro,
  dropdownHome,
  dropdownContentManagement,
  dropdownContentTrainingManagement,
  dropdownViewsReport,
  dropdownContentReportManagement,
} from "../store/modules/menu/index.js";

import { getNameUser } from "../utils/user/user.js";
import router from "../router";
import { startGuidedTour } from "../modules/tour/GuidedTourService.js";

export default {
  props: ["userImage"],
  components: {
    CustomDropdown,
    DropdownDivider,
    DropdownItem,
    Dropdown,
    DigitalCheckin,
  },
  computed: {
    userName() {
      return getNameUser();
    },
    dropdownInstitucional() {
      return dropdownInstitucional;
    },
    dropdownCadastro() {
      return dropdownCadastro;
    },
    dropdownDeclaracoes() {
      return dropdownDeclaracoes;
    },
    dropdownConsultorioVirtual() {
      return dropdownConsultorioVirtual;
    },
    dropdownContentReportManagement() {
      return dropdownContentReportManagement;
    },
    dropdownBeneficios() {
      return dropdownBeneficios;
    },
    dropdownFinanceiro() {
      return dropdownFinanceiro;
    },
    dropdownHome() {
      return dropdownHome;
    },
    dropContentManagement() {
      return dropdownContentManagement;
    },
    dropContentTraining() {
      return dropdownContentTrainingManagement;
    },
    dropViewsReport() {
      return dropdownViewsReport;
    },
    PermissionList() {
      return PermissionList;
    },
  },
  data() {
    return {
      linkInstitucional: RoutesPaths.institutionalPage.rootName(),
      linkCadastro: RoutesPaths.register.rootName(),
      linkDeclaracoes: RoutesPaths.declarations.rootName(),
      linkConsultorioVirtual: RoutesPaths.virtualOffice.rootName(),
      linkBeneficios: RoutesPaths.benefit.rootName(),
      linkFinanceiro: RoutesPaths.financial.rootName(),
      linkContentManagement: RoutesPaths.contentManagement.rootName(),
      linkContentTrainingManagement:
        RoutesPaths.contentTrainingManagement.rootName(),
      linkContentReportManagement:
        RoutesPaths.contentReportManagement.rootName(),
      linkFileManagement: RoutesPaths.fileManagement.rootName(),
      linkHome: RoutesPaths.home.rootName(),
      linkViewsReport: RoutesPaths.reports.rootName(),
    };
  },
  methods: {
    async openCheckin() { },
    getHome() {
      router.push({
        path: RoutesPaths.home.rootName(),
        replace: true,
      });
    },
    validateRole(role) {
      return isAble(role);
    },
    selectRoute(routeCurrent) {
      return this.$route.matched.some((rota) => rota.path == routeCurrent);
    },
    openImageProfileModal() {
      this.$bvModal.show("profile-image-modal");
    },
    async changePassword() {
      this.$bvModal.show("change-password-modal");
    },
    async navigateRequestHistory() {
      this.$router.push({
        path: RoutesPaths.requestHistory.rootName(),
        replace: true,
      });
    },
    onClickUseTerm() {
      this.$router.push(RoutesPaths.useTerm.accepted());
    },
    startTourManually() {
      const username = this.$store.getters.getUserName;
      if (!username) return;

      let tourData = JSON.parse(localStorage.getItem(`tour_cooperado_${username}`)) || { seen: false, skips: 0 };
      tourData.seen = false;
      tourData.skips = 0;
      localStorage.setItem(`tour_cooperado_${username}`, JSON.stringify(tourData));

      // Import methods have a callback if we want
      startGuidedTour(() => {
        // Define as seen only if it was not seen before 
        let updatedData = JSON.parse(localStorage.getItem(`tour_cooperado_${username}`)) || { seen: false, skips: 0 };
        updatedData.seen = true;
        localStorage.setItem(`tour_cooperado_${username}`, JSON.stringify(updatedData));
      });
      this.closeAllDropdowns();
    },
    async logout() {
      try {
        this.$store.dispatch("logout");

        this.$router.push({
          path: RoutesPaths.login.rootName(),
          query: { isApp: this.$store.getters.isApp },
        });
      } catch (error) {
        console.error("logout", error);
      }
    },
    selectNavItemClick(item) {
      this.$router.push({ path: item });
    },
    closeAllDropdowns() {
      this.$refs.navbarCollapse.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-img-gr {
  display: flex;
  height: 6.5rem;
  width: 6.5rem;
  margin-right: 1rem;
  justify-content: center;
  align-content: center;
  align-items: center;
  padding: 0.3rem;
  border: 0.2rem solid var(--primary);
  border-radius: 60%;
  position: relative;

  img {
    height: 5rem;
    width: 5rem;
    border-radius: 60%;
  }
}

.icon-photos {
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: white;
  border-radius: 60%;

  img {
    height: 2.5rem;
    width: 2.5rem;
  }
}

.menu {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.dropdown-item-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#nav-collapse .nav-link {
  @include header4;
  color: var(--grey-1);
  padding-right: 0.5rem;

  @media screen and (max-width: 1112px) {
    @include header5;
    color: var(--grey-1);
    padding-right: 0.5rem;
  }

  @media screen and (max-width: 920px) and (min-width: 768px) {
    @include header6;
    color: var(--grey-1);
    padding-right: 0.2rem;
  }
}

#nav-collapse .nav-link.active {
  color: var(--dark);
}

.status-custom {
  margin-bottom: 0rem;
}

.logo {
  width: 9.7rem;
  height: 5.2rem;

  @media screen and (max-width: 1112px) {
    width: 8.7rem;
    height: 4.2rem;
  }

  @media screen and (max-width: 920px) and (min-width: 768px) {
    width: 7.7rem;
    height: 4.2rem;
  }
}

.clickable {
  cursor: pointer;
}

.logout-item {
  &__icon {
    font-size: 20px;
    margin-right: 8px;
    color: #B22222;
  }

  &__text {
    color: #B22222;
    margin-bottom: 0;
  }

  &:hover &__text {
    color: var(--primary);
  }
}

@media screen and (max-width: 816px) {
  .logo-container-mobile {
    margin-left: 15px;
  }

}

.custom-toggler {
  &:focus {
    outline: none;
    box-shadow: none;
  }
}

.toggle-icon {
  color: var(--primary);
  /* You can change this color to whatever you prefer */
  font-size: 1.8rem;
}
</style>
